export default "__VITE_ASSET__eb6f5281__"